.container {
    overflow: auto;
    height: calc(100% - 50px);
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    margin-top: 16px;
}
